
import React from "react";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";

interface CreateGameButtonProps {
  onClick: () => void;
}

const CreateGameButton = ({ onClick }: CreateGameButtonProps) => {
  return (
    <Button 
      className="w-full flex items-center justify-center gap-2 bg-forest hover:bg-forest/90 text-white mb-6"
      onClick={onClick}
    >
      <PlusCircle className="h-4 w-4" />
      <span>Create New Game</span>
    </Button>
  );
};

export default CreateGameButton;
